import { compose, withHandlers } from 'recompose'
import { reduxForm, SubmissionError } from 'redux-form'
import { connect } from 'react-redux'

import {
  Input,
  Button,
  Select,
  FormControlWrapper
} from '../uiLib'
import {
  getPATSCode
} from '../../reducers/security-code'
import { defaultValidators, reduxErrorFormatter } from '../../lib/validation'
import SecurityCodeRequestStatus from './SecurityCodeRequestStatus'
import { notify } from '../../lib/notification'

const reasonCodes = [
  { value: 'PCMReplacement', label: 'PCMReplacement' },
  { value: 'ReprogramKey', label: 'ReprogramKey' }
]


const PATCodeForm = props => {
  const { t, loading } = props
  return (
    <div>
      <div className="is-size-5 m-b-md">{t('common:pats-page-content-12')}</div>
      <div className="m-b-sm">{t('common:pats-page-content-14')}</div>
      { props.pats.request_sent ? (
        <SecurityCodeRequestStatus
          securityCode={props.pats}
          setCodeType={props.setCodeType}
          handleResetForm={props.handleResetForm}
          type="pats"
          t={t}
        />
      ) : (
        <form
          onSubmit={props.handleSubmit(props._handleSubmit)}>
          <Input
            id="vin"
            name="vin"
            size="normal"
            label={t('common:vin')}
            formComponent
            type="text"
            placeholder={t('common:enter-vin')}
            disabled={loading}
            validate={[
              defaultValidators.required,
              defaultValidators.length(17)
            ]} />
          <Input
            id="part_number"
            name="part_number"
            size="normal"
            label={t('common:part-number')}
            formComponent
            type="text"
            placeholder={t('common:enter-part-number')}
            disabled={loading}
            validate={[
                defaultValidators.required
              ]} />
          <Input
            id="serial_number"
            name="serial_number"
            size="normal"
            label={t('common:serial-number')}
            formComponent
            type="text"
            placeholder={t('common:enter-serial-number')}
            disabled={loading}
            validate={[
                defaultValidators.required
              ]} />
          <Input
            id="error_control_number"
            name="error_control_number"
            size="normal"
            label={t('common:error-control-number')}
            formComponent
            type="text"
            placeholder={t('common:enter-error-control-number')}
            disabled={loading}
            validate={[
                defaultValidators.required
              ]} />
          <Input
            id="out_code"
            name="out_code"
            size="normal"
            label={t('common:out-code')}
            formComponent
            type="text"
            placeholder={t('common:enter-out-code')}
            disabled={loading}
            help="(Separate submissions for each module (PCM, BCM, etc) Out Code received is required.)"
            validate={[
              defaultValidators.required              
            ]} />
          <Select
            id="reason"
            name="reason"
            label={props.t('common:reason')}
            size="normal"
            required
            formComponent            
            placeholder={props.t('common:please-select')}
            validate={[defaultValidators.required]}
            values={reasonCodes}
          />          
          <FormControlWrapper
            labelOffset
          >
            <div className="m-t-md is-pulled-right">
              <Button
                outlined
                btType="default"
                onClick={() => props.setCodeType('')}
                disabled={loading}
                loading={loading}
              >
                {t('common:back')}
              </Button>
              <Button
                outlined
                btType="primary "
                disabled={loading}
                loading={loading}
                className="m-l-md"
              >
                {t('common:submit')}
              </Button>
            </div>
          </FormControlWrapper>
        </form>
      ) }
    </div>
  )
}

const mapStateToProps = state => ({
  pats: state.securityCode.pats,
  loading: state.securityCode.loading,
  error: state.securityCode.error
})

const mapDispatchToProps = dispatch => ({
  createNotification: opts => dispatch(notify(opts)),
  getPATSCode: car_data => dispatch(getPATSCode(car_data))
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    _handleSubmit: ({ getPATSCode,t ,createNotification }) => data => {
      return getPATSCode(data)
      .catch(err => {
        let reduxFormErr = {
          _error: t('server-error')
        }

        if (err.response.status === 400) {
          reduxFormErr = {
            ...reduxFormErr,
            ...reduxErrorFormatter(err.response.data)
          }
        } else {
          createNotification({
            type: 'error',
            message: t('server-error')
          })
        }
        throw new SubmissionError(reduxFormErr)
      })
    }
  }),
  reduxForm({
    destroyOnUnmount: false,
    form: 'pat_code'
  })
)(PATCodeForm)



// WEBPACK FOOTER //
// ./components/PATSCodes/PATCodeForm.js